'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
// Return true if window + document

exports.default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);


//////////////////
// WEBPACK FOOTER
// ./~/react-images/lib/utils/canUseDom.js
// module id = 1195
// module chunks = 157105401581058 254038247484913